import { render, staticRenderFns } from "./contactCenHzzx.vue?vue&type=template&id=a82c1800&scoped=true&"
import script from "./contactCenHzzx.vue?vue&type=script&lang=js&"
export * from "./contactCenHzzx.vue?vue&type=script&lang=js&"
import style1 from "./contactCenHzzx.vue?vue&type=style&index=1&id=a82c1800&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82c1800",
  null
  
)

export default component.exports